import axios from 'axios';

import { BASE_API_URL } from '../../../lib/utils';

export const getServerVersion = async () => {
  return axios<{ version: string }>({ baseURL: BASE_API_URL, method: 'GET', url: '/api/settings/version' });
};
